<template>
  <base-popup ref="popupNotification">
    <template #icon>
      <svg
        width="32"
        height="28"
        viewBox="0 0 32 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.6088 0.340515C31.5277 0.953429 31.7758 2.19522 31.1629 3.11414L15.0873 27.2156L1.03726 12.1694C0.28339 11.362 0.326718 10.0965 1.13403 9.34259C1.94135 8.58872 3.20694 8.63205 3.9608 9.43937L14.5629 20.7932L27.8352 0.894583C28.4481 -0.024335 29.6899 -0.2724 30.6088 0.340515Z"
          fill="#F2F2F2"
        />
      </svg>
    </template>
    <template #content>
      <div v-if="custom" class="custom-block">
        <div class="custom-block__description">
          <span>{{ displayCustomText }}</span>
        </div>
        <div class="custom-block__action">
          <div class="close-btn">
            <primary-button
              :label="$t('add-gate.notification.close')"
              @click="closePopup"
            ></primary-button>
          </div>
        </div>
      </div>
      <span v-else v-html="displayMessage"></span>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'

export default {
  name: 'SuccessNotification',
  components: { BasePopup, PrimaryButton },
  props: {
    text: {
      type: String,
    },

    custom: {
      type: Boolean,
      default: false,
    },
  },
  // props: ["text"],
  data() {
    return {
      timeoutHandler: null,
      message: null,
      localCustomText: '',
      successMessages: {
        success: 'success',
        equal: 'wallets_are_equal',
        to_wallet: 'to_wallet_not_found',
        from_wallet: 'from_wallet_not_found',
        from_partner: 'need_select_from_partner',
        to_partner: 'need_select_to_partner',
        to_sub_wallet: 'to_sub_wallet_not_found',
        from_sub_wallet: 'from_sub_wallet_not_found',
        transfer: 'error_create_transfer',
        pushner_error: 'pushner_error',
      },
    }
  },

  computed: {
    displayMessage() {
      return this.message ? this.message : this.text
    },

    displayCustomText() {
      return this.localCustomText ? this.localCustomText : ''
    },
  },

  methods: {
    async openCustomPopup(successMessage) {
      const errorCode = Object.keys(successMessage)[0]
      this.localCustomText = this.successMessages[errorCode] || successMessage

      return await this.$refs.popupNotification.open()
    },

    show(timeoutSeconds = 2) {
      this.removeTimeoutHandler()

      let _timeToShow = timeoutSeconds * 1000

      this.timeoutHandler = setTimeout(() => {
        this.$refs.popupNotification.close()
      }, _timeToShow)

      return this.$refs.popupNotification.open()
    },
    removeTimeoutHandler() {
      if (this.timeoutHandler) {
        clearInterval(this.timeoutHandler)
      }
    },

    async closePopup() {
      return await this.$refs.popupNotification.close()
    },
  },
  beforeUnmount() {
    this.removeTimeoutHandler()
  },
}
</script>

<style lang="scss" scoped>
.custom-block {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .custom-block__description {
    line-height: 20px;
    span {
      font-weight: 500;
      font-size: 14px;
    }
  }

  .custom-block__action {
    width: 210px;
    margin: 20px auto 0;
  }
}
</style>
